import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {VanBanDenXL} from '../../models/vanbanden/vanbandenxl';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {ToTrinhXuLy} from '../../models/totrinh/totrinhxuly';
import {VanBanDenComment} from '../../models/vanbanden/vanbandencomment';
const apiUrl = `${environment.apiUrl}/api/info/vanbandenxl`;

@Injectable({
  providedIn: 'root'
})
export class VanBanDenXLService {
  constructor(public httpService: HttpClient) { }

  public getAll(): Observable<VanBanDenXL[]> {
    return this.httpService.get<VanBanDenXL[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new VanBanDenXL().deserialize(data)))
    );
  }
  public getAllByMaVB(id: number): Observable<VanBanDenXL[]> {
    return this.httpService.get<VanBanDenXL[]>(`${apiUrl}/getallbymavb/${id}`).pipe(
      map(data => data.map(data => new VanBanDenXL().deserialize(data)))
    );
  }
  public add(params: Object): Observable<VanBanDenXL>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new VanBanDenXL().deserialize(data)));

  }
  public setGiaoThem(id: number, uids: string)
  {
    return this.httpService.get(`${apiUrl}/giaothem?id=${id}&uids=${uids}`
    ).pipe(
      map(data => Number(data)));
  }
  public update(params: Object): Observable<VanBanDenXL>
  {
    return this.httpService.post(`${apiUrl}/update`, params).pipe(
      map(data => new VanBanDenXL().deserialize(data)));

  }
  public getCountByKeyword(keyword: string, status: string, phoCap: number, maNguoiXuLy: number,
  nguoiChuTriId: number)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?keyword=${keyword}&st=${status}`
                                    +`&pc=${phoCap}&nid=${maNguoiXuLy}&cid=${nguoiChuTriId}`).pipe(
      map(data => Number(data)));
  }
  public xuLyLai(id: number, status: number,  nguoiChuTriId: number)
  {
    return this.httpService.get(`${apiUrl}/xulylai?id=${id}&st=${status}`
      +`&uid=${nguoiChuTriId}`).pipe(
      map(data => Number(data)));
  }
  public getById(id: number): Observable<VanBanDenXL>
  {
    return this.httpService.get<VanBanDenXL>(`${apiUrl}/findbyid/${id}`).pipe(
      map(data => new VanBanDenXL().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public getByMaVBAndMXL(id: number, staffId: number): Observable<VanBanDenXL>
  {
    return this.httpService.get<VanBanDenXL>(`${apiUrl}/getbymavbandmaxl/${id}?uid=${staffId}`).pipe(
      map(data => new VanBanDenXL().deserialize(data)),
      catchError((error: HttpErrorResponse) => throwError(error.message))
    );
  }
  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  public deleteMulti(id: number, ids: string): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/deletemulti/${id}?ids=${ids}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  findByKeyword(keyword: String): Observable<VanBanDenXL[]> {
    return this.httpService.get<VanBanDenXL[]>(`${apiUrl}/findbykeyword?keyword=${keyword}`).pipe(
      map(data => data.map(data => new VanBanDenXL().deserialize(data)))
    );
  }
  findAllByPaging(keyword: String, status: string, phoCap: number, maNguoiXuLy: number,
                  nguoiChuTriId: number, page: number, size: number): Observable<VanBanDenXL[]> {
    return this.httpService.get<VanBanDenXL[]>(`${apiUrl}/getallpaging?key=${keyword}&st=${status}`
                                    +`&pc=${phoCap}&nid=${maNguoiXuLy}&cid=${nguoiChuTriId}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new VanBanDenXL().deserialize(data)))
    );
  }
  public changeStatus(id: number, status: number, staffId: number): Observable<Number>
  {
    return this.httpService.get<ToTrinhXuLy>(`${apiUrl}/changestatus/${id}?st=${status}&uid=${staffId}`).pipe(
      map(data => Number(data)),
      catchError(() => throwError('items not found'))
    );
  }
  findByMaVB(id: number): Observable<VanBanDenXL[]> {
    return this.httpService.get<VanBanDenXL[]>(`${apiUrl}/getallbymavb/${id}`).pipe(
      map(data => data.map(data => new VanBanDenXL().deserialize(data)))
    );
  }
  public updateXuLy(params: Object): Observable<number>
  {
    return this.httpService.post(`${apiUrl}/updatexuly`, params).pipe(
      map(data => Number(data)));

  }
  public changeView(id: number,  staffId: number): Observable<Number>
  {
    return this.httpService.get<VanBanDenXL>(`${apiUrl}/changeview/${id}?uid=${staffId}`).pipe(
      map(data => Number(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public addXuLy(id: number, uid: string, tht: number, tdc2: number, tt: number, nct: number, butPhe: string): Observable<VanBanDenXL>
  {
    return this.httpService.post(`${apiUrl}/addxuly?id=${id}&tht=${tht}&tdc2=${tdc2}&tt=${tt}&uids=${uid}&nct=${nct}`, butPhe).pipe(
      map(data => new VanBanDenXL().deserialize(data)));
  }
  findAllCommentByMaVB(id: number): Observable<VanBanDenComment[]> {
    return this.httpService.get<VanBanDenComment[]>(`${apiUrl}/getallcommentbymvb?id=${id}`).pipe(
      map(data => data.map(data => new VanBanDenComment().deserialize(data)))
    );
  }
}
